import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@zond/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AttendancePeriodType } from '../../hooks/useAttendanceData';

interface AttendanceControlsProps {
  selectedPeriod: AttendancePeriodType;
  showAverageOnly: boolean;
  onPeriodChange: (value: AttendancePeriodType) => void;
  onModeChange: (isAverage: boolean) => void;
  hideDisplayModeSwitch?: boolean;
}

export const AttendanceControls: React.FC<AttendanceControlsProps> = ({
  selectedPeriod,
  showAverageOnly,
  onPeriodChange,
  onModeChange,
  hideDisplayModeSwitch = false,
}) => {
  const { t } = useTranslation('dashboard');

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h3 className="font-semibold">{t('attendance.title')}</h3>
          <p className="text-sm text-muted-foreground">{t('attendance.subtitle')}</p>
        </div>
        <Select
          value={selectedPeriod}
          onValueChange={(value) => onPeriodChange(value as AttendancePeriodType)}
        >
          <SelectTrigger className="w-[160px]">
            <SelectValue placeholder={t('period.placeholder')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="current_month">{t('attendance.currentMonth')}</SelectItem>
            <SelectItem value="last_3_months">{t('attendance.last3Months')}</SelectItem>
            <SelectItem value="last_6_months">{t('attendance.last6Months')}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {!hideDisplayModeSwitch && (
        <div className="mb-4 flex justify-start">
          <button
            className={`text-xs px-3 py-1 rounded-md mr-2 ${showAverageOnly ? 'bg-muted' : 'border'}`}
            onClick={() => onModeChange(true)}
          >
            {t('attendance.average')}
          </button>
          <button
            className={`text-xs px-3 py-1 rounded-md ${!showAverageOnly ? 'bg-muted' : 'border'}`}
            onClick={() => onModeChange(false)}
          >
            {t('attendance.individual')}
          </button>
        </div>
      )}
    </>
  );
};
